/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../../routing/state-utils';
import {stateTitleView} from '../../common/directives/html/state-title.component';
import {NudePreviewPageComponent} from './nude-preview-page.component';


export function previewStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
const providerParams = {
          url: '/preview-creative/?uuid&creativeId&networkId&creativeWidth&creativeHeight&lineItemId&lineItemCode&layoutType&dataLang&previewLanguage',
          views: {
            'content@nude': {
              component: NudePreviewPageComponent
            },
            'title@nude': stateTitleView()
          },
          data: {
            public: true,
            preview: true,
            title: "{{previewData.pageTitle}}"
          }
        };
    
        $stateProvider
          .state('nude.preview', providerParams);
  }, adnRouterHelper);
}
